/**
 * What an audience is called on screen.
 *
 * The ids are the contract — they ride every record, every url and every API
 * call, and they are not renamed here or anywhere. This is a display layer: the
 * console is read by colleagues who have no reason to know that "company-general"
 * is an audience key rather than a place.
 *
 * An id with no entry falls back to itself, so adding an audience never breaks
 * the page — it just shows up under its own name until someone names it.
 */
const LABELS: Record<string, string> = {
  "company-general": "Everyone at Monterro",
  investment: "Investment team",
  talent: "Talent team",
}

export function audienceLabel(id: string): string {
  return LABELS[id] ?? id
}

/** The id, shown alongside the label where a steward may need the real key. */
export function audienceHint(id: string): string | null {
  return LABELS[id] ? id : null
}
